import { DEFAULT_MONTH_SCALE, DEFAULT_WEEK_SCALE } from './constants';

/**
 * 標準在庫指数（min or max）の値と単位をまとめたインターフェース
 * @property {number} value - 値
 * @property {string} unit - 単位
 */
export interface IStdInventoryIndicesInfo {
  value: number;
  unit: string;
}

/**
 * 標準在庫指数の値をunitに合わせて日に変換する
 * ex) value = 2.5, unit = "month" => 75
 * @param value - 指数の値
 * @param unit - 単位
 */
export const convertStdInventoryIndexToDays = (value: number, unit: string): number => {
  let output = -1;
  if (value < 0) return output;

  if (unit === 'ヶ月' || unit === 'month') {
    output = Math.round(value * DEFAULT_MONTH_SCALE);
  } else if (unit === '週' || unit === 'week') {
    output = value * DEFAULT_WEEK_SCALE;
  } else if (unit === '日' || unit === 'day') {
    output = value;
  }
  return output;
};
